import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AuthService } from '../service';
import { Router } from '@angular/router';
import { AuthNewService } from '../service/auth-new.service';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { fetchAuthSession } from 'aws-amplify/auth';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private router: Router,
        private AuthService: AuthNewService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
         if (req.headers.has('X-Skip-Interceptor')) {
            const cloned = req.clone({
                headers: req.headers.delete('X-Skip-Interceptor') // remove the marker header
            });
            return next.handle(cloned); // skip auth header
        }
        return from(this.getAuth(req, next));
    }

    async getAuth(req: HttpRequest<any>, next: HttpHandler) {
        const session = await fetchAuthSession();
        const token = session?.tokens?.idToken?.toString();
        if (token) {
            req = req.clone({ headers: req.headers.append('Authorization', token) });
        }

        return next.handle(req).toPromise();
    }


}
